export default "__VITE_ASSET__C6xu6ZXh__"